import { Stack } from "@mui/material";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import LangBtn from "./LangBtn";
import Footer from "./Footer";

export default function MainLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return (
    <Stack
      sx={{
        minHeight: "100vh",
      }}
    >
      {/* <LangBtn /> */}
      <Outlet />
      <Footer />
    </Stack>
  );
}
